import DatePicker from "react-datepicker";
import { styled } from "@mui/material/styles";

const FormMain = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "30px",
  marginBottom: "50px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "70%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "50%",
  },
  "& label": { color: "rgba(11, 11, 11, 0.5)" },
  "& input": { color: "#0B0B0B" },
  "& .AuthInputMain ": { paddingBottom: "30px" },
  "& .css-1rk6wwj ": { top: "74%" },

  "& .ButtonMain": {
    alignItems: "center",
    display: "flex",
    gap: "30px",
    marginBottom: "50px",
  },
}));

const ErrorSpan = styled("span")(({ theme }) => ({
  color: "red",
  fontWeight: 400,
  fontSize: "14px",
  fontFamily: theme.typography.fontFamily,
}));

const FileUploadWrap = styled("div")(({ theme }) => ({
  width: "100%",
  position: "relative",
  marginBottom: "20px",
  "& .CargoImageImages": {
    display: "flex",
    gap: "15px",
    marginTop: "8px",
    "& img": {
      width: "80px",
      height: "80px",
      objectFit: "cover",
    },
  },
  "& label": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    "& span.ButtonLabel": {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  },
  "& .MuiButtonBase-root": {
    display: "flex",
    background: "#F2F2F2",
    borderRadius: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    height: "48px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    boxShadow: "none",
    textTransform: "inherit",
    "&:hover": { background: "#F2F2F2" },
  },
  "& .ButtonContainer": {
    display: "flex",
    background: "#F2F2F2",
    borderRadius: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    height: "48px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    boxShadow: "none",
    textTransform: "inherit",
    "&:hover": { background: "#F2F2F2" },
  },
  "& .errorSpan": { position: "absolute", top: "100%", left: "0" },
  [theme.breakpoints.down("md")]: {
    marginBottom: "15px",
  },
}));
const InputFlexWrap = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "5px",
  gap: "20px",
  "& .AuthInputMain": { width: "100%" },
  "&.CargoNameFlexWrap": {
    gap: "10px",
    width: "100%",
    "& .AuthInputMain:first-child": { width: "100%" },
    "& .AuthInputMain:last-child": { width: "70%" },
    [theme.breakpoints.down("md")]: {
      gap: "5px",
      flexDirection: "row",
    },
  },
  "& .DimensionsFlexWrap": {
    gap: "10px",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      gap: "5px",
      flexDirection: "row",
    },
  },
  flexDirection: "row",
  [theme.breakpoints.down("md")]: {
    gap: "5px",
    flexDirection: "column",
  },
}));

const CargoDescription = styled("div")(({ theme }) => ({
  marginTop: "25px",
  "& label": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& textarea": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    width: "100%",
    background: "#F2F2F2",
    borderRadius: "10px",
    border: "none",
    padding: "10px",
    resize: "none",
    height: "140px",
    fontFamily: theme.typography.fontFamily,
  },
  "&.haveBorder textarea": { border: "1px solid red" },
}));

const DateTimeWrap = styled("div")(({ theme }) => ({
  position: "relative",
  "& label": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  width: "100%",
  "& .react-datepicker-wrapper": {
    display: "block",
  },
  "& .react-datepicker__input-container": {
    width: "100%",
  },
  "& .react-datepicker__input-container input": {
    width: "100%",
    height: "48px",
    padding: "8px",
    background: "#F2F2F2",
    borderRadius: "10px",
    fontSize: "16px",
    border: "none",
    fontFamily: theme.typography.fontFamily,
  },
  "& .errorSpan": {
    position: "absolute",
    top: "100%",
    left: "0",
  },
}));

const CustomDateTime = styled(DatePicker)(({ theme }) => ({
  "& .react-datepicker": {
    backgroundColor: "#B2B2B2 !important",
    background: "#B2B2B2 !important",
  },
}));
export {
  FormMain,
  ErrorSpan,
  FileUploadWrap,
  InputFlexWrap,
  CargoDescription,
  CustomDateTime,
  DateTimeWrap,
};
